import { render, staticRenderFns } from "./superdocument.vue?vue&type=template&id=5ff262c4&scoped=true&"
import script from "./superdocument.vue?vue&type=script&lang=js&"
export * from "./superdocument.vue?vue&type=script&lang=js&"
import style0 from "./superdocument.vue?vue&type=style&index=0&id=5ff262c4&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff262c4",
  null
  
)

export default component.exports